import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CommonService {
  private encryptSecretKey

  constructor() { 
    this.encryptSecretKey = "cira-encript-@12"

  }

  formatTableData(data) {
    let tableOject: any = {};
    let tableArray: any = [["#"]];
    let i = 0;
    for (let item of data) {
      for (let key of Object.keys(item)) {
        tableArray[0].push(key);
        if (i < 1) {
          for (let col of Object.keys(item[key])) {
            tableArray.push([col]);
          }
        }
        let j = 1;
        for (let col of Object.keys(item[key])) {
          tableArray[j].push(item[key][col]);
          j++;
        }
        i++;
      }
    }

    tableOject["header"] = tableArray[0];
    tableOject["body"] = [];
    let _i = 0;
    for (let item of tableArray) {
      if (_i != 0)
        tableOject["body"].push(item);
      _i++;
    }
   
    return tableOject;
  }

  encryptData(data) {

    try {
 
      return btoa(data.toString()) 
    } catch (e) {
      console.log(e);
    }
  }

  decryptData(data) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      console.log(e);
    }
  }

  clearText() {
    return '';
  }

  typeaheadKeydown($event: KeyboardEvent, instance) {
    
    if (instance.isPopupOpen()) {
      setTimeout(() => {
        const popup = document.getElementById(instance.popupId);
        const activeElements = popup.getElementsByClassName('active');
        if (activeElements.length === 1) {
          // activeElements[0].scrollIntoView();
          const elem = (activeElements[0] as any);
          if (typeof elem.scrollIntoViewIfNeeded === 'function') {
            // non standard function, but works (in chrome)...
            elem.scrollIntoViewIfNeeded();
          } else {
            //do custom scroll calculation or use jQuery Plugin or ...
            // this.scrollIntoViewIfNeededPolyfill(elem as HTMLElement);
          }
        }
      });
    }
  }

}
